// extracted by mini-css-extract-plugin
module.exports = {"unit":"8px","title":"ring-down-notification-title","error":"ring-down-notification-error"};